export default __webpack_public_path__ + "locales/about.ru.json";